// NPM Imports
import React from "react";

// Component Imports
import AddCustomDynamicField from "./AddCustomDynamicField";
import AddCustomDynamicFieldUpgrade from "./AddCustomDynamicFieldUpgrade";
import { FeatureGating } from "../../../../../commonComponents";

// Internal Imports
import { FEATURES } from "../../../../../constants";

// Destructuring
const { FEATURES_NAME } = FEATURES;

export default function(props) {
  return (
    <FeatureGating
      name={FEATURES_NAME.TEMPLATES_CUSTOM_VARIABLES}
      altComponent={
        <AddCustomDynamicFieldUpgrade
          featureName={FEATURES_NAME.TEMPLATES_CUSTOM_VARIABLES}
        />
      }>
      <AddCustomDynamicField {...props} />
    </FeatureGating>
  );
}



// WEBPACK FOOTER //
// ./src/components/Document/DynamicField/DynamicFieldSelect/AddCustomDynamicField/index.js